import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { SharedAnalyticsService } from '@luggagehero/shared/services/analytics';
import { SharedLoggingService } from '@luggagehero/shared/services/logging';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { BaseComponent, ILang } from '../../../core';
import { ChangeAction, Languages } from '../../../i18n';
import { IAppState } from '../../../ngrx/state/app.state';

@Component({
  template: '',
  standalone: false,
})
export class LangSwitcherBaseComponent extends BaseComponent implements OnInit {
  private analytics = inject(SharedAnalyticsService);
  private store = inject<Store<IAppState>>(Store);
  private log = inject(SharedLoggingService);
  private cd = inject(ChangeDetectorRef);
  private languages = inject(Languages);

  public supportedLanguages: Array<ILang>;
  private _lang: string;

  constructor() {
    super();

    this.store.pipe(take(1)).subscribe((s) => {
      this.lang = s.i18n.lang;
    });
  }

  public get selectedLanguageTitle(): string {
    return this.supportedLanguages.find((l) => l.code === this.lang).title;
  }

  public get lang(): string {
    return this._lang;
  }
  public set lang(value: string) {
    this._lang = value;
    this.cd.markForCheck();
  }

  public ngOnInit() {
    this.supportedLanguages = this.languages;
  }

  public changeLang(e: ILang) {
    let lang = this.supportedLanguages[0].code; // fallback to default 'en'

    if (e && e.code) {
      lang = e.code;
    }

    this.analytics.track('ChangeLanguage', { category: 'Multilingual', label: lang });
    void this.log.debug(`Language change: ${lang}`);
    this.store.dispatch(new ChangeAction(lang));

    this.lang = lang;
  }
}
